/* eslint-disable no-console */
import React from "react";
import { PropTypes } from "prop-types";
import { Logo } from "@bca/ui-library";
import { useDispatch } from "react-redux";
import {
  StyledButton,
  StyledFlag,
  StyledHeader,
  StyledImg,
  StyledLanguage,
  StyledLanguageSelectorContainer,
  StyledLine,
  StyledLink,
  StyledLinksContainer,
  StyledMobileButtonContainer,
  StyledSpace,
} from "./Header.styled";
import RGB_BCA_SVG from "../../images/RGB_BCA_AUTOENCHERES.svg";
import { resetForm } from "../../reducers/formSlice";
import { resetLanguageState } from "../../reducers/languageOptionsSlice";

const Header = ({
  isMobile,
  onLanguageClick,
  language,
  headerBcaUrl,
  headerBcaText,
  onMenuClick,
  countrySelected,
}) => {
  const dispatch = useDispatch();

  if (language === "da") {
    language = "dk";
  }
  if (language === "sv") {
    language = "se";
  }
  if (language === "cs") {
    language = "cz";
  }
  if (language === "sr") {
    language = "rs";
  }

  return (
    <StyledHeader isMobile={isMobile}>
      {countrySelected === "FR" ? (
        <StyledImg src={RGB_BCA_SVG} alt="BCA Logo" isMobile={isMobile} />
      ) : (
        <Logo />
      )}

      {isMobile && (
        <StyledLanguage
          isMobile={isMobile}
          onClick={onLanguageClick}
          data-cy="header-language-select"
        >
          {language.toUpperCase()}
          <StyledFlag
            code={language.toLowerCase() === "en" ? "GB" : language}
            height="16"
          />
        </StyledLanguage>
      )}
      {!isMobile && (
        <StyledLinksContainer isMobile={isMobile}>
          <StyledLink
            key={headerBcaUrl}
            href={headerBcaUrl}
            removeMargin={countrySelected === "FR"}
            onClick={() => {
              dispatch(resetForm());
              dispatch(resetLanguageState());
            }}
          >
            {headerBcaText}
          </StyledLink>
        </StyledLinksContainer>
      )}
      {!isMobile && (
        <StyledLanguageSelectorContainer>
          <StyledSpace />
          <StyledLanguage
            onClick={onLanguageClick}
            data-cy="header-language-select"
          >
            {language.toUpperCase()}{" "}
            <StyledFlag
              code={language.toLowerCase() === "en" ? "GB" : language}
              height="16"
            />
          </StyledLanguage>
        </StyledLanguageSelectorContainer>
      )}
      {isMobile && (
        <StyledMobileButtonContainer>
          <StyledSpace />
          <StyledButton
            data-cy="mobile-menu-button"
            type="submit"
            onClick={onMenuClick}
          >
            <StyledLine />
            <StyledLine />
            <StyledLine />
          </StyledButton>
        </StyledMobileButtonContainer>
      )}
    </StyledHeader>
  );
};

Header.propTypes = {
  isMobile: PropTypes.bool,
  onLanguageClick: PropTypes.func.isRequired,
  language: PropTypes.string,
  headerBcaUrl: PropTypes.string,
  headerBcaText: PropTypes.string,
  onMenuClick: PropTypes.func.isRequired,
  countrySelected: PropTypes.string,
};

Header.defaultProps = {
  isMobile: false,
  language: "",
  headerBcaUrl: "",
  headerBcaText: "",
  countrySelected: "",
};

export default Header;
